import { ReactComponent as PeoplesPensionLogo } from "@/integrations/peoplePension/assets/people-pension-logo.svg";
import { ReactComponent as QuickbooksLogo } from "@/integrations/quickbooks/assets/quickbooks-icon.svg";
import { ReactComponent as SmartPensionLogo } from "@/integrations/smartPension/assets/smart-pension-logo.svg";
import { ReactComponent as ViftoLogo } from "@/integrations/vifto/assets/vifto-logo-small.svg";
import { ReactComponent as XeroLogo } from "@/integrations/xero/assets/xero-logo.svg";
import { connect } from "react-redux";

import { Actions as PEOPLES_PENSION_ACTIONS } from "@/integrations/peoplePension/store/peoplesPensionActions";
import { Actions as QUICKBOOKS_ACTIONS } from "@/integrations/quickbooks/store/quickbooksActions";
import { Actions as SMART_PENSION_ACTIONS } from "@/integrations/smartPension/store/smartPensionActions";
import { Actions as ACCOUNTING_INTEGRATION_ACTIONS } from "@/integrations/accountingIntegrations/store/accountingIntegrationActions";
import { Actions as PENSION_INTEGRATION_ACTIONS } from "@/integrations/pensionIntegrations/store/pensionIntegrationActions";
import { Actions as PAYMENT_INTEGRATION_ACTIONS } from "@/integrations/paymentIntegrations/store/paymentIntegrationActions";
import { Actions as VIFTO_ACTIONS } from "@/integrations/vifto/store/viftoActions";
import { Actions as XERO_ACTIONS } from "@/integrations/xero/store/xeroActions";
import { ActionListOption } from "@/components/common/custom-selectors/ActionList";
import { camelCase } from "lodash";

const logos = {
	"Vifto": ViftoLogo,
	"Xero": XeroLogo,
	"Quickbooks": QuickbooksLogo,
	"People's Pension": PeoplesPensionLogo,
	"Smart Pension": SmartPensionLogo,
};

const hasPayrollData = Object.keys(logos);

const IntegrationSendPayrollData = ({ integrations, onClick, periodId }) => {
	const integrationList = integrations?.map((i) => ({
		label: `Send To ${i.name}`,
		icon: logos[i.name] || i.logo,
		onClick: () => {
			if (onClick[i.name]) onClick[i.name](periodId);
			if (onClick[i.section]) onClick[i.section](i.name, periodId);
		},
	}));

	return (
		<>
			{integrationList.map((option) => {
				return <ActionListOption {...{ option }} />;
			})}
		</>
	);
};

const mapStateToProps = (state, { periodId, period }) => {
	const integrations = Object.entries(state.integration || {})?.reduce((prev, [section, curr]) => {
		Object.values(curr || {})?.map(({ name, payPeriods, payruns }) => {
			const { functionality, logo } = state.integrationDetails?.[section]?.[camelCase(name)] || {};

			const payCheck1 = payPeriods?.map(({ payPeriodId }) => payPeriodId)?.includes(periodId);
			const payCheck2 = payruns?.includes(periodId);
			const payCheck3 = period?.sentToAccountingIntegration;
			if (!hasPayrollData.includes(name) && !functionality?.payroll?.send) return;
			if (payCheck1 || payCheck2 || payCheck3) return;
			prev.push({ name, logo, section });
		});
		return prev;
	}, []);
	return {
		integrations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	onClick: {
		"Vifto": (periodId) => dispatch(VIFTO_ACTIONS.sendPayPeriodToVifto(periodId)),
		"Smart Pension": (periodId) => dispatch(SMART_PENSION_ACTIONS.sendPayPeriodToSmartPension(periodId)),
		"Xero": (periodId) => dispatch(XERO_ACTIONS.sendPayPeriodToXero(periodId)),
		"Quickbooks": (periodId) => dispatch(QUICKBOOKS_ACTIONS.sendPayPeriodToQuickbooks(periodId)),
		"People's Pension": (periodId) => dispatch(PEOPLES_PENSION_ACTIONS.sendPayPeriodToPeoplesPension(periodId)),
		"accounting": (integration, periodId) =>
			dispatch(ACCOUNTING_INTEGRATION_ACTIONS.sendPayPeriodToPensionIntegration(integration, periodId)),
		"pension": (integration, periodId) =>
			dispatch(PENSION_INTEGRATION_ACTIONS.sendPayPeriodToPensionIntegration(integration, periodId)),
		"payment": (integration, periodId) =>
			dispatch(PAYMENT_INTEGRATION_ACTIONS.openPaymentModal(integration, periodId)),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationSendPayrollData);
